var filtering = document.querySelector('#filtering')
if (filtering) {
    console.log("Filtering js active");
    var posts = document.querySelectorAll('[data-tags]')
    var tagPool = [];
    var showFilters = document.querySelector('#js-filters')
    postCounter('posts')
    // console.log(posts)

    for (i = 0; i < posts.length; i++) {
        var tags = posts[i].dataset.tags
        if (tags.length > 0) {
            var tagList = tags.split(",");
            tagList.forEach(tag => {
                tagPool.push(tag)
            });
        }
    }

    const counts = [];
    tagPool.forEach(function (x) { counts[x] = (counts[x] || 0) + 1; }); // Counts each key count
    console.log(counts);

    if (tagPool.length > 0) {
        
        let uniqueTags = [...new Set(tagPool)]
        console.log('tagPool:: ',uniqueTags)
        uniqueTags.forEach(tag => {
            var filterButton = document.createElement("button");
            filterButton.innerHTML = tag + " <span class='ml-2 badge badge-light pointer-events-none'>" + counts[tag] + "</span>";
            filterButton.classList.add("btn")
            filterButton.classList.add("button")
            filterButton.classList.add("tag-filter")
            filterButton.classList.add("rounded")
            filterButton.classList.add("mx-1")
            filterButton.classList.add("my-1")
            filterButton.setAttribute('data-filter', 'posts')
            filterButton.setAttribute('data-filter-tag', tag)
            showFilters.appendChild(filterButton)
            
        });

        /*
            All or reset button. 
            Not really needed as deactiving filters removes all filters
        */
        // var allButton = document.createElement("button");
        // allButton.innerHTML = "All"
        // allButton.classList.add("btn")
        // allButton.classList.add("button")
        // allButton.classList.add("tag-filter")
        // allButton.classList.add("mx-1")
        // allButton.setAttribute('data-filter', 'posts')
        // allButton.setAttribute('data-reset', true)
        // showFilters.appendChild(allButton)

    }

    
    var filterButtons = document.querySelectorAll('[data-filter=posts]');
    
    for (var i = 0; i < filterButtons.length; i++) {
        filterButtons[i].addEventListener('click', function (e) {
            var button = e.target;
            var filter = button.getAttribute('data-filter');
            var tag    = button.getAttribute('data-filter-tag');
            var state = button.classList.contains('filter-active')

            if (button.getAttribute('data-reset') === 'true') {
                resetFilter(filter);
                resetPost(filter);
            } 
            else {
                if (state === true) {
                    resetFilter(filter);
                    resetPost(filter);
                }
                else {
                    filterTag(filter, tag);
                    button.classList.add('filter-active')
                }
            }

            postCounter(filter)

        });
    
    }
    
    
    
    function postCounter (filter) {
        // Show post count
        var posts = document.querySelectorAll('.' + filter + ' > [data-tags]');
        var postCount = document.querySelector('#postCount');
        var activePostCount = document.querySelector('#activePostCount');
        postCount.innerHTML = posts.length

        // var hiddenPosts = posts.classList.contains('post-hidden');
        var c = 0;
        for (var i = 0; i < posts.length; i++) {
            // console.log(posts[i]);
            if (posts[i].classList.contains('post-hidden')) {
                c++
            }
        }

        var showingNow = posts.length - c
        activePostCount.innerHTML = showingNow;
    }





    function filterTag (filter, tag) {
        var posts = document.querySelectorAll('.' + filter + ' > [data-tags]');
    
        for (var i = 0; i < posts.length; i++) {
            var itemTags = posts[i].getAttribute('data-tags');
    
            if ((typeof(itemTags) !== 'undefined') && (itemTags !== null) && (itemTags.length > 0)) {
                if (itemTags.indexOf(tag) < 0) {
                    console.log("FilterTAG");
                    posts[i].classList.add('post-hidden')
                }
            }
            else {
                // Posts with no tags. Need to be hidden if any buttons are active
                var activeFilters = document.querySelectorAll(".filter-active")
    
                if (activeFilters) {
                    // alert("hide no tags")
                    posts[i].classList.add("post-hidden")
                }
    
            }
        }
    }
    
    
    
    // Reset filters
    function resetFilter (filter) {
        var buttons = document.querySelectorAll('[data-filter=' + filter + ']');
    
        for (var i = 0; i < buttons.length; i++) {
            buttons[i].classList.remove('filter-active')
        }
    }
    
    function resetPost (filter) {
        var posts = document.querySelectorAll('.' + filter + ' > [data-tags]');
    
        for (var i = 0; i < posts.length; i++) {
            posts[i].classList.remove('post-hidden')
        }
    }
}
